// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"73fa21f5","703":"d556ff83","787":"5d5bd52a"}[chunkId] + ".chunk.js";
};